import { Pill, Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { isEmpty } from "lodash";

import { type TagInclude } from "../../../types/fetchPlacements.schema";
import { formatTagNamesAsString } from "../../../utils";

interface PlacementTagsPillProps {
  tags: TagInclude[] | undefined;
}

export function PlacementTagsPill(props: PlacementTagsPillProps) {
  const { tags } = props;

  if (!isDefined(tags) || isEmpty(tags)) {
    return null;
  }

  const allTags = formatTagNamesAsString(tags, { sort: true, abbreviateTags: true });

  if (isEmpty(allTags)) {
    return null;
  }

  return (
    <Pill
      variant="filled"
      size="small"
      label={
        <Stack
          direction="row"
          gap={1}
          overflow="hidden"
          whiteSpace="nowrap"
          textOverflow="ellipsis"
        >
          <Text
            overflow="hidden"
            whiteSpace="nowrap"
            textOverflow="ellipsis"
            variant="body2"
            sx={{ color: (theme) => theme.palette.intent?.warning.text }}
          >
            {allTags}
          </Text>
        </Stack>
      }
      backgroundColor={(theme) => theme.palette.intent?.warning.background}
      sx={{ width: "fit-content", alignSelf: "flex-start" }}
    />
  );
}
